"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LogoLoader_1 = require("./LogoLoader");
exports.default = LogoLoader_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/Loader/LogoLoader/index.js
// module id = 1712
// module chunks = 8